import {Address} from "./Address";
import {Contact} from "./Contact";
import {HealthProvider} from "./HealthProvider";
import {
  DeserializedRecord,
  deserializeItem,
  deserializeManyRelationship,
  Deserializer,
  deserializeSingleRelationship,
  JSONAPIManyRelationship,
  JSONAPIRecord,
  JSONAPIReference,
  JSONAPISingleRelationship
} from "./Helpers";
import {deserializeVersion, Version} from "./Version";

interface Institution extends DeserializedRecord<"institution"> {
  address?: Address;
  contacts?: Contact[];
  name: string;
  description?: string;
  healthProvider?: HealthProvider;
  people: Array<JSONAPIReference<'person'>>;
  uniqueType?: 'bsnr';
  uniqueId?: string;
  versions: Array<Version<Institution>>;
}

interface InstitutionData extends JSONAPIRecord {
  relationships: {
    address: JSONAPISingleRelationship;
    contacts: JSONAPIManyRelationship;
    health_provider: JSONAPISingleRelationship;
    people: JSONAPIManyRelationship;
    versions: JSONAPIManyRelationship;
  }
}

const deserializeInstitution: Deserializer<Institution, InstitutionData> = (data, included) => {
  const address = deserializeSingleRelationship(data.relationships.address, included, deserializeItem<Address>);
  const contacts = deserializeManyRelationship(data.relationships.contacts, included, deserializeItem<Contact>);
  const healthProvider = deserializeSingleRelationship(data.relationships.health_provider, included, deserializeItem<HealthProvider>);
  const people = deserializeManyRelationship<JSONAPIReference<'person'>>(data.relationships.people, included);
  const versions = deserializeManyRelationship(data.relationships.versions, included, deserializeVersion as Deserializer<Version<Institution>>);

  return {
    ...deserializeItem(data),
    address,
    contacts,
    healthProvider,
    people,
    versions
  };
};

export {
  deserializeInstitution,
  Institution
};
